import {
  Component,
  Input,
  HostBinding,
  ChangeDetectionStrategy,
} from '@angular/core';

type CardPadding = 'none' | 'sm' | 'md' | 'lg';

@Component({
  selector: 'app-galaxy-card',
  imports: [],
  templateUrl: './galaxy-card.component.html',
  styleUrls: ['./galaxy-card.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GalaxyCardComponent {
  @Input() hoverEffect = true;
  @Input() padding: CardPadding = 'md';

  @HostBinding('class')
  get hostClasses(): string {
    return [
      'liquid-glass',
      this.hoverEffect ? 'group hover-effect' : '',
      `padding-${this.padding}`,
    ].join(' ');
  }
}
